import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { evaluationActionPlanIdDelete } from "#performance-evaluation/services/api"
import { Box, Typography } from "@mui/material"
import { useReloadRefresh } from "app/reload"
import { useState } from "react"

export default function ActionPlanDelete({ open = true, setOpen, actionPlan }) {
	const { refresh } = useReloadRefresh()
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		refresh()
		setOpen(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(evaluationActionPlanIdDelete, { success, end })
	const handleSubmit = () => {
		setDisabled(true)
		fetch(actionPlan.id)
	}

	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				maxWidth: "sm",
				handleSubmit,
				title: "Eliminar Plan de Acción",
				disabled,
			}}
		>
			<Box p={2} display="flex" flexDirection="column" gap={2}>
				<Typography variant="body1" align="center">
					¿Estás seguro de que deseas Eliminar el Plan de Acción de la competencia
					<strong>{actionPlan.competencia_name}</strong>?
				</Typography>
			</Box>
		</DialogMaster>
	)
}
